import Vue from 'vue'
// export default new Vue()
const Bus = new Vue()
export default Bus